module.exports = __webpack_public_path__ + "images/automatic-scouts/setting_complete_ja_2-14ec1277d6ac7d3300a87510e3ee2310.png";